import { useIntl } from "react-intl";

import { Image } from "@/components/atoms/Image";
import { Text } from "@/components/atoms/Text";

type ToolCardProps = {
  imageSrc: string;
  title: string;
  description: string;
};

const ToolCard = ({ imageSrc, title, description }: ToolCardProps) => {
  const intl = useIntl();

  return (
    <div className="tw-w-full tw-h-full tw-rounded-[4.5px] tw-overflow-hidden tw-bg-brand-white tw-shadow-xl">
      <div className="tw-w-full lg:tw-max-h-[360px] tw-max-h-[280px] tw-overflow-hidden tw-select-none tw-pointer-events-none">
        <Image
          src={imageSrc}
          alt={intl.formatMessage({
            defaultMessage: "Tool card",
          })}
        />
      </div>
      <div className="tw-px-16 tw-py-16 lg:tw-px-20 lg:tw-py-24 tw-flex tw-flex-col">
        <Text
          element="h3"
          typeface="body-2-m"
          className="lg:tw-headline-3-b tw-text-gray-900"
        >
          {title}
        </Text>
        <Text
          element="p"
          typeface="caption-2"
          className="lg:tw-body-2 tw-text-gray-600"
        >
          {description}
        </Text>
      </div>
    </div>
  );
};

export { ToolCard };
